import React, { Fragment, useState, useEffect, useContext } from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import records from '../../../Services/records'
import { appContext } from "../../../Utils/context";
import { toast, Slide } from "react-toastify";
import { Multiselect } from "react-widgets";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Button, Spinner
} from "reactstrap";

function Lists({ newTags, setNewTags, uatId, list, setList}) {
    const {myLists, setMyLists, user} = useContext(appContext)
    const [value, setValue] = useState([])
    const [tags, setTags] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [ajaxRequesting, setAjaxRequesting] = useState(false)
    const [deleteRequesting, setDeleteRequesting] = useState(false)
    const [particularTag, setParticularTag] = useState('')
    const [listed, setListed] = useState([])


    useEffect(() => {
        if(uatId){
        const record = list.filter(li => uatId === li.uat_id)  
        setListed(record[0]?.list_ids)        
    } 
        }, [uatId,list])


    const addTags = () => {
        // Check if there are any values in the 'value' state
        if (value.length !== 0) {
            // Filter out values that are already in the 'tags' state
            const newtag = value.filter((tag) => !tags.includes(tag));

            if (newtag.length === 0) {
                // All values in 'value' are duplicates, show a warning
                notify22("All Selected tags are already Added", "warning");
            } else {
                // There are non-duplicate values, proceed with the addition
                if(uatId !== undefined && uatId !== null){
                setAjaxRequesting(true);
                const info ={
                    user_tags: `${[...tags, ...newtag]}`
                }
                records
                    .addNewTags(uatId.toString(),info)
                    .then((res) => {
                        const tagsArray = res.data?.user_tags ? res.data?.user_tags.split(',') : [];
                        setTags(tagsArray);
                        setNewTags(res.data);
                        const updatedList = list.map((object) => {
                            if (object.uat_id === uatId) {
                              return { ...object, tags_count: res.data.tags_count };
                            }
                            return object;
                          });
                          setList(updatedList)
                        setValue([]);
                        notify22("Tags Added", "success");
                    })
                    .catch((err) => {
                        console.log("erroriz ", err);
                    })
                    .finally(() => setAjaxRequesting(false));}
                    else{
                        setNewTags({...newTags,user_tags:`${[...tags, ...newtag]}` })
                        setValue([]);
                        notify22("Tags Added", "success");
                    }
                // records
                //     .AddTags({
                //         uat_id: uatId.toString(),
                //         status_type: "tags",
                //         status_value: `{"status": "${[...tags, ...newTags]}"}`,
                //     })
                //     .then((res) => {
                //         setTags([...tags, ...newTags]);
                //         setValue([]);
                //         notify22("Tags Added", "success");
                //     })
                //     .catch((err) => {
                //         console.log("erroriz ", err);
                //     })
                //     .finally(() => setAjaxRequesting(false));
            }
        } else {
            notify22("Select / Add at least 1 Tag", "warning");
        }
    };

    const deleteTag = (id) => {
        setDeleteRequesting(true)
        setParticularTag(id)
        const dellist = listed.filter(li => li != id)
        const info=
      {
        "uat_ids":[uatId].join(',') ,
        "list_ids": dellist.join(',')
        }
        records
      .postListConnection(info).then((res)=>{
                // Assuming 'myObjects' is your array of objects
                const updatedObjects = list.map(obj => {
                  // Check if 'uat_id' exists and is included in the array of items
                  if (uatId === obj.uat_id) {
                    // If 'uat_id' exists in the array of items, update the 'list_ids' property
                    return { ...obj, list_ids: dellist };
                  }
                  return obj; // Return the original object if 'uat_id' is not included
                });
                setList(updatedObjects)
        notify22("Updated", "success");
        setDeleteRequesting(false)
      }).catch((err)=>{
        notify22("Server Error", "error");
        setDeleteRequesting(false)
      })        







        // setDeleteRequesting(true)
        // setParticularTag(tagToDelete)
        // const updatedTags = tags.filter((tag) => tag !== tagToDelete);
        // if(uatId !== undefined && uatId !== null){
        // const data ={
        //     user_tags: `${updatedTags}`
        // }
        // records
        //     .addNewTags(uatId.toString(),data)
        //     .then((res) => {
        //         const tagsArray = res.data?.user_tags ? res.data?.user_tags.split(',') : [];
        //         setTags(tagsArray);
        //         setNewTags(res.data);
        //         const updatedList = list.map((object) => {
        //             if (object.uat_id === uatId) {
        //               return { ...object, tags_count:res.data.tags_count };
        //             }
        //             return object;
        //           });
        //         setList(updatedList)
        //         setValue([]);
        //         notify22("Tags Deleted", "success");
        //     })
        //     .catch((err) => {
        //         console.log("erroriz ", err);
        //     })
        //     .finally(() => {setDeleteRequesting(false)
        //                 setParticularTag('')})}
        //                 else{
        //                     setNewTags({...newTags,user_tags:`${updatedTags}` })
        //                     setValue([]);
        //                     setDeleteRequesting(false)
        //                     notify22("Tags Deleted", "success");
        //                 }
    };


    const notify22 = (msg, type) =>
        toast(msg, {
            transition: Slide,
            autoClose: 5000,
            position: "top-right",
            type: type,

        });
  return (
    <Fragment>
    <TransitionGroup>
        <CSSTransition component="div" classNames="TabsAnimation" appear={true}
            timeout={0} enter={false} exit={false}>
            <div >
                <Row>
                    <Col md="12">
                        <Card className="main-card mb-2">
                            <CardBody>
                                <CardTitle>Add Lists</CardTitle>
                                <Row className="g-2">
                                    <Col xs="12">
                                        <Multiselect data={myLists} value={value} placeholder="Add to a list"
                                            onChange={(value) => { setValue(value) }} textField="list_name"
                                        />
                                    </Col>
                                    <Col xs="6" className="mt-1">
                                        <Button block outline className=" btn-wide mb-1 btn-transition" color="primary" onClick={() => setValue([])} >
                                            Clear
                                        </Button>
                                    </Col>
                                    <Col xs="6" className="mt-1">
                                        <Button block outline className=" btn-wide mb-1 btn-transition" color="primary" onClick={addTags} >
                                            {ajaxRequesting ? <><Spinner size="sm" /><span>{' '} Adding</span> </>
                                                : "Add"}
                                        </Button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md="12">
                        <Card className="main-card mb-2">
                            <CardBody>
                                <CardTitle>Added Lists</CardTitle>
                                {isLoading ? (
                                    <>
                                        <Row className="mb-1 g-2">
                                            <Col xs="3"><Skeleton height={30} /></Col>
                                            <Col xs="3"><Skeleton height={30} /></Col>
                                            <Col xs="3"><Skeleton height={30} /></Col>
                                            <Col xs="3"><Skeleton height={30} /></Col>
                                            <Col xs="3"><Skeleton height={30} /></Col>
                                            <Col xs="3"><Skeleton height={30} /></Col>
                                            <Col xs="3"><Skeleton height={30} /></Col>
                                        </Row>

                                    </>
                                ) : (
                                    <>
                                        {myLists?.map((v, k) => {
                                            if (listed.includes(v.id)) {
                                                return(
                                            <Fragment key={k}>
                                                <span className="badge rounded-pill text-capitalize me-2 p-2 mb-1" style={{ backgroundColor: "#002D62" }}>

                                                    {
                                                        deleteRequesting && particularTag === v.id ? (
                                                            <>{v?.list_name}{' '} <Spinner size="sm" className="" /></>
                                                        ) : (
                                                            <>
                                                                {v?.list_name}{' '}
                                                                <span className="fw-bold ms-2 text-info" role="button" onClick={() => deleteTag(v?.id)}>
                                                                    X
                                                                </span>
                                                            </>
                                                        )
                                                    }
                                                </span>
                                            </Fragment>)}
                                        })}
                                    </>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </CSSTransition>
    </TransitionGroup>
</Fragment>
  )
}

export default Lists